import { Text, View } from '@react-pdf/renderer';
import React, { FC } from 'react';
import { IntlFormatters } from '@formatjs/intl/src/types';

import { styles } from 'components/ProfileActions/ResumePdf/styles';
import messages from '../messages';

type ResumePdfGeneralInfoProps = {
  formatMessage: IntlFormatters['formatMessage'];
  profile: AH$Profile;
};

export const ResumePdfGeneralInfo: FC<ResumePdfGeneralInfoProps> = ({ profile, formatMessage }) =>
  profile.displaySummary ? (
    <View style={styles.section}>
      <Text style={[styles.subheading, styles.bold, styles.spaceBottomBig]}>
        {formatMessage(messages.generalInfo)}
      </Text>
      <Text style={styles.text}>{profile.displaySummary}</Text>
    </View>
  ) : null;
